export interface FeatureFlagsV2 {
  MICROAPP: MicroappFeatureFlags,
  UI: UIFeatureFlags,
  MISC: MiscFeatureFlags,
  SHOP: ShopFeatureFlags,
  ZUORA: ZuoraFeatureFlags,
  LD: LDFeatureFlags
}

export enum MicroappFeatureFlagsEnum {
  GARAGE = 'OC.MAIN.GARAGE',
  VEHICLE_PROFILE = 'OC.MAIN.VEHICLEPROFILE',
  PLAN_DETAILS = 'OC.MAIN.PLANDETAILS',
  RECALLS = 'OC.MAIN.RECALLS',
  SHOP = 'OC.MAIN.SHOP',
  ONSTAR_LEARN = 'OC.MAIN.ONSTAR.LEARN',
  OSS = 'OC.MAIN.OSS',
  OSS_EDIT = 'OC.MAIN.OSSEDIT',
  CHECKOUT_WAVE2 = 'OC.MAIN.CHECKOUTWAVE2',
  BILLING_HISTORY = 'OC.MAIN.BILLINGHISTORY'
}
interface MicroappFeatureFlags {
  [MicroappFeatureFlagsEnum.GARAGE]: boolean
  [MicroappFeatureFlagsEnum.VEHICLE_PROFILE]: boolean
  [MicroappFeatureFlagsEnum.PLAN_DETAILS]: boolean
  [MicroappFeatureFlagsEnum.RECALLS]: boolean
  [MicroappFeatureFlagsEnum.SHOP]: boolean
  [MicroappFeatureFlagsEnum.ONSTAR_LEARN]: boolean
  [MicroappFeatureFlagsEnum.OSS]: boolean
  [MicroappFeatureFlagsEnum.OSS_EDIT]: boolean
  [MicroappFeatureFlagsEnum.CHECKOUT_WAVE2]: boolean
  [MicroappFeatureFlagsEnum.BILLING_HISTORY]: boolean
}
export enum UIFeatureFlagsEnum {
  OC_CHAT_LIVE = 'OC.CHAT.LIVE',
  OC_CHAT_SALESFORCE = 'OC.CHAT.SALESFORCE',
  OC_CHAT_OC = 'OC.CHAT.OC',
  OC_CHAT_AKAMAI = 'OC.CHAT.AKAMAI',
  OC_GARAGE = 'OC.GARAGE',
  OC_PCI_ADD_PAYMENT = 'OC.PCI.ADD.PAYMENT',
  OC_EXPERIENCE_GM_HOST = 'OC.EXPERIENCE.GM.HOST',
  OC_EXPERIENCE_BRAND_REDIRECT = 'OC.EXPERIENCE.BRAND.REDIRECT',
  ADD_PAYMENT_PAYPAL = 'ADD.PAYMENT.PAYPAL',
  OC_TRACKING_OMNI = 'OC.TRACKING.OMNI',
  OC_TRACKING_DATALAYERV2 = 'OC.TRACKING.DATALAYERV2',
  OC_CHECKOUT = 'OC.CHECKOUT',
  SHOP_ASSETS_V2 = 'SHOP.ASSETS.V2',
  OC_CANCELLATION = 'OC.CANCELLATION',
  OC_REBUTTAL_OFFER = 'OC.REBUTTAL.OFFER',
  PAYMENT_HISTORY_REDESIGN = 'PAYMENT.HISTORY.REDESIGN',
  CANCEL_REASONS_REVIEW = 'OC.CANCEL.REASONS.REVIEW',
  EXPERIENCE_DEEPLINK = 'OC.EXPERIENCE.DEEPLINK',
  KOREA_DEALER_LOCATION = 'UI_OC.KOREA.DEALER.LOCATION',
  OC_INTERIM_CATALOG = 'OC.INTERIM.CATALOG',
  OC_TELUS = 'OC.TELUS',
  OC_SHOPIFY = 'OC.SHOPIFY.A',
  OC_SHOPIFY_NEW_TAB = 'OC.SHOPIFY.NEW.TAB.A',
  OC_FTC_ENABLED = 'OC.FTC.ENABLED'
}
interface UIFeatureFlags {
  [UIFeatureFlagsEnum.OC_CHAT_LIVE]: boolean
  [UIFeatureFlagsEnum.OC_CHAT_SALESFORCE]: boolean
  [UIFeatureFlagsEnum.OC_CHAT_OC]: boolean
  [UIFeatureFlagsEnum.OC_CHAT_AKAMAI]: boolean
  [UIFeatureFlagsEnum.OC_GARAGE]: boolean
  [UIFeatureFlagsEnum.OC_PCI_ADD_PAYMENT]: boolean
  [UIFeatureFlagsEnum.OC_EXPERIENCE_GM_HOST]: string
  [UIFeatureFlagsEnum.OC_EXPERIENCE_BRAND_REDIRECT]: boolean
  [UIFeatureFlagsEnum.ADD_PAYMENT_PAYPAL]: boolean
  [UIFeatureFlagsEnum.OC_TRACKING_OMNI]: boolean
  [UIFeatureFlagsEnum.OC_TRACKING_DATALAYERV2]: boolean
  [UIFeatureFlagsEnum.OC_CHECKOUT]: boolean
  [UIFeatureFlagsEnum.SHOP_ASSETS_V2]: boolean
  [UIFeatureFlagsEnum.OC_CANCELLATION]: boolean
  [UIFeatureFlagsEnum.OC_REBUTTAL_OFFER]: boolean
  [UIFeatureFlagsEnum.PAYMENT_HISTORY_REDESIGN]: boolean,
  [UIFeatureFlagsEnum.CANCEL_REASONS_REVIEW]: boolean,
  [UIFeatureFlagsEnum.EXPERIENCE_DEEPLINK]: boolean,
  [UIFeatureFlagsEnum.KOREA_DEALER_LOCATION]: boolean,
  [UIFeatureFlagsEnum.OC_INTERIM_CATALOG] : boolean,
  [UIFeatureFlagsEnum.OC_TELUS] : boolean,
  [UIFeatureFlagsEnum.OC_SHOPIFY]: boolean,
  [UIFeatureFlagsEnum.OC_SHOPIFY_NEW_TAB]: boolean,
  [UIFeatureFlagsEnum.OC_FTC_ENABLED]: boolean
}
export enum MiscFeatureFlagsEnum {
  CHECKOUT_BUTTON_COLOR_PREF = 'CHECKOUT-BUTTON-COLOR-PREF'
}
interface MiscFeatureFlags {
  [MiscFeatureFlagsEnum.CHECKOUT_BUTTON_COLOR_PREF]: string
}
export enum ShopFeatureFlagsEnum {
  SHOP_ALL_PLANS_LINK = 'SHOP.ALL.PLANS.LINK',
  DLP_VARIATION = 'DLP.VARIATION',
  PREMIUM_VARIATION = 'PREMIUM.VARIATION'
}
interface ShopFeatureFlags {
  [ShopFeatureFlagsEnum.SHOP_ALL_PLANS_LINK]: boolean
  [ShopFeatureFlagsEnum.DLP_VARIATION]: string
  [ShopFeatureFlagsEnum.PREMIUM_VARIATION]: string
}
export enum ZuoraFeatureFlagsEnum {
  ACH_PAGE_ID = 'ACH_PAGE_ID',
  CC_PAGE_ID = 'CC_PAGE_ID'
}
interface ZuoraFeatureFlags {
  [ZuoraFeatureFlagsEnum.ACH_PAGE_ID]: string
  [ZuoraFeatureFlagsEnum.CC_PAGE_ID]: string
}
export enum LDFeatureFlagsEnum {
  ENV_MILFORD = 'ENV_MILFORD',
  ENV_WARREN = 'ENV_WARREN',
  ENV = 'ENV'
}
interface LDFeatureFlags {
  [LDFeatureFlagsEnum.ENV_MILFORD]: boolean
  [LDFeatureFlagsEnum.ENV_WARREN]: boolean
  [LDFeatureFlagsEnum.ENV]: string
}

// ------------------------------------------------------------
// Deprecated
// ------------------------------------------------------------

/**
 * @deprecated Use `MicroappFeatureFlagsEnum` instead
 */
export const MicroappFeatureFlag = {
  GARAGE: 'OC.MAIN.GARAGE',
  VEHICLE_PROFILE: 'OC.MAIN.VEHICLEPROFILE',
  PLAN_DETAILS: 'OC.MAIN.PLANDETAILS',
  RECALLS: 'OC.MAIN.RECALLS',
  SHOP: 'OC.MAIN.SHOP',
  ONSTAR_LEARN: 'OC.MAIN.ONSTAR.LEARN',
  OSS: 'OC.MAIN.OSS',
  OSS_EDIT: 'OC.MAIN.OSSEDIT',
  CHECKOUT: 'OC.MAIN.CHECKOUTWAVE2',
  BILLING_HISTORY: 'OC.MAIN.BILLINGHISTORY'
} as const;
/**
 * @deprecated Use `MicroappFeatureFlagsEnum` instead
 */
export type MicroappFeatureFlag = ObjectValues<typeof MicroappFeatureFlag>;
/**
 * @deprecated Use `UIFeatureFlagsEnum` instead
 */
export const UIFeatureFlag = {
  CHAT_LIVE: 'OC.CHAT.LIVE',
  CHAT_SALESFORCE: 'OC.CHAT.SALESFORCE',
  CHAT_OC: 'OC.CHAT.OC',
  CHAT_AKAMAI: 'OC.CHAT.AKAMAI',
  GARAGE: 'OC.GARAGE',
  PCI_ADD_PAYMENT: 'OC.PCI.ADD.PAYMENT',
  EXPERIENCE_GM_HOST: 'OC.EXPERIENCE.GM.HOST',
  EXPERIENCE_BRAND_REDIRECT: 'OC.EXPERIENCE.BRAND.REDIRECT',
  ADD_PAYMENT_PAYPAL: 'ADD.PAYMENT.PAYPAL',
  OMNITURE_TRACKING: 'OC.TRACKING.OMNI',
  DATALAYER_V2:'OC.TRACKING.DATALAYERV2',
  CHECKOUT: 'OC.CHECKOUT',
  ASSETS: 'SHOP.ASSETS.V2',
  CANCELLATION: 'OC.CANCELLATION',
  REBUTTAL_OFFER: 'OC.REBUTTAL.OFFER',
  PAYMENT_HISTORY_REDESIGN: 'PAYMENT.HISTORY.REDESIGN',
  CANCEL_REASONS_REVIEW: 'OC.CANCEL.REASONS.REVIEW',
  EXPERIENCE_DEEPLINK: 'OC.EXPERIENCE.DEEPLINK',
  KOREA_DEALER_LOCATION : 'OC.KOREA.DEALER.LOCATION',
  INTERIM_CATALOG: 'OC.INTERIM.CATALOG'
} as const;
/**
 * @deprecated Use `UIFeatureFlagsEnum` instead
 */
export type UIFeatureFlag = ObjectValues<typeof UIFeatureFlag>;
/**
 * @deprecated Use `MiscFeatureFlagsEnum` instead
 */
export const FeatureVariable = {
  CHECKOUT_BUTTON_COLOR_PREF: 'CHECKOUT-BUTTON-COLOR-PREF',
  /** @deprecated Use `ZUORA_ACH_PAGE_ID` inside `ZuoraFeatureFlag` instead */
  ZUORA_ACH_PAGE_ID: 'ZUORA_ACH_PAGE_ID',
  /** @deprecated Use `ZUORA_CC_PAGE_ID` inside `ZuoraFeatureFlag` instead */
  ZUORA_CC_PAGE_ID: 'ZUORA_CC_PAGE_ID'
} as const;
/**
 * @deprecated Use `MiscFeatureFlagsEnum` instead
 */
export type FeatureVariable = ObjectValues<typeof FeatureVariable>;
/**
 * @deprecated Use `ShopFeatureFlagsEnum` instead
 */
export const ShopFeatureFlag = {
  SHOP_ALL_PLANS_LINK : 'SHOP.ALL.PLANS.LINK',
  DLP_VARIATION: 'DLP.VARIATION',
  PREMIUM_VARIATION: 'PREMIUM.VARIATION'
} as const;
/**
 * @deprecated Use `ShopFeatureFlagsEnum` instead
 */
export type ShopFeatureFlag = ObjectValues<typeof ShopFeatureFlag>;
/**
 * @deprecated Use `ZuoraFeatureFlagsEnum` instead
 */
export const ZuoraFeatureFlag = {
  ZUORA_ACH_PAGE_ID: 'ACH_PAGE_ID',
  ZUORA_CC_PAGE_ID: 'CC_PAGE_ID'
} as const;
/**
 * @deprecated Use `ZuoraFeatureFlagsEnum` instead
 */
export type ZuoraFeatureFlag = ObjectValues<typeof ZuoraFeatureFlag>;
/**
 * @deprecated Use `LDFeatureFlagsEnum` instead
 */
export const LDFeatureFlag = {
  LD_ENV_MILFORD: 'ENV_MILFORD',
  LD_ENV_WARREN: 'ENV_WARREN',
  LD_ENV: 'ENV'
} as const;
/**
 * @deprecated Use `LDFeatureFlagsEnum` instead
 */
export type LDFeatureFlag = ObjectValues<typeof LDFeatureFlag>;

/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
type MICROAPP = {
  [key in ObjectValues<typeof MicroappFeatureFlag>]: string;
};
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
type MISC = {
  [key in ObjectValues<typeof FeatureVariable>]: string;
};
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
type UI = {
  [key in ObjectValues<typeof UIFeatureFlag>]: string;
};
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
type SHOP = {
  [key in ObjectValues<typeof ShopFeatureFlag>]: string;
};
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
type ZUORA = {
  [key in ObjectValues<typeof ZuoraFeatureFlag>]: string;
};
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
type LD = {
  [key in ObjectValues<typeof LDFeatureFlag>]: string;
};
/**
 * @deprecated 
 */
type ObjectValues<T> = T[keyof T];
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
export type FlagGroup = keyof FeatureFlags;
/**
 * @deprecated Use feature flag enums instead
 */
export type Flag =
  ObjectValues<typeof FeatureVariable>
  | ObjectValues<typeof MicroappFeatureFlag>
  | ObjectValues<typeof UIFeatureFlag>
  | ObjectValues<typeof ShopFeatureFlag>
  | ObjectValues<typeof ZuoraFeatureFlag>
  | ObjectValues<typeof LDFeatureFlag>;
/**
 * @deprecated Use `FeatureFlagsV2` instead
 */
export interface FeatureFlags {
  MICROAPP: MICROAPP,
  UI: UI,
  MISC: MISC,
  SHOP: SHOP,
  ZUORA: ZUORA,
  LD: LD
}
